


















import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { StringMap } from '../../utils/map'

@Component
export default class UnifyButton extends Vue {
  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly disabled!: boolean

  @Prop({
    default: 'global-loader',
    type: [Boolean, String],
  })
  public readonly loading!: boolean | string

  @Prop({
    default: 'small',
    type: String,
  })
  public readonly size!: string

  @Prop({
    default: 'none',
    type: String,
  })
  public readonly buttonStyle!: 'default' | 'none'

  public sizes: StringMap<number | string> = {
    small: 'small',
    medium: 20,
    big: 30,
  }

  public styles: StringMap<string> = {
    default:
      'u-btn-outline-teal g-font-weight-600 g-letter-spacing-0_5 g-brd-2 g-rounded-0--md small false',
    none: 'btn rounded-0',
  }

  get classes() {
    const style = this.styles[this.buttonStyle]

    return [style, this.size || 'small', this.$wait.is(this.loading ? 'loading' : '')].join(' ')
  }

  get isLoading(): boolean {
    let loading: boolean

    if (typeof this.loading === 'boolean') {
      loading = this.loading
    } else {
      loading = this.$wait.is(this.loading)
    }

    return loading
  }

  public click(event: Event) {
    this.$emit('click', event)
  }

  public mapSize(size: string): number | string {
    return this.sizes[size]
  }
}
